export default __webpack_public_path__ + "static/media/nomissed.b61e8390.jpg";